import { Duration } from '../../types/duration';
import { Time } from '../../types/time';

const DISTANCE_BETWEEN_MARKS = 80;

export const checkIsDistanceBetweenMarkersSufficient = ({
    cursorPositionOnTimeline,
    timelineWidth,
    currentTime,
    duration,
}: {
    cursorPositionOnTimeline: number;
    timelineWidth: number;
    currentTime: Time;
    duration: Duration;
}) =>
    Math.abs(cursorPositionOnTimeline - duration.getPercentFromTime(currentTime) * timelineWidth) >
    DISTANCE_BETWEEN_MARKS;
